import basic from '../home/en';
export default { ...basic };
